// Dentro de la app de kiosko el menú NO se sirve desde internet: la app lo
// espeja al disco del iPad y lo publica en un servidor HTTP local (127.0.0.1).
// Ese servidor respeta las mismas rutas que el backend real, así que basta con
// usar rutas relativas para que todo salga del disco.
//
// Fuera del kiosko (navegador normal) se usan las absolutas de siempre.

const REMOTE = 'https://admin.boostmymenu.com';

export const isLocalMirror =
  typeof window !== 'undefined' &&
  (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost');

//const base = isLocalMirror ? '' : REMOTE;
const base = REMOTE;

export const constants = {
   isLocalMirror,
   apiServer: `${base}/api`,
   pathImagesIntro: `${base}/images/intros`,
   pathImagesMenu: `${base}/images/menus`,
   pathImagesTags: `${base}/images/tags`,
   pathIconCategories: `${base}/images/categories/icons`,
   pathLogoRestaurant: `${base}/images/restaurants/logos`,
   pathScreenSavers: `${base}/images/screen_savers`,
   pathVideosRestaurant: `${base}/videos/restaurants`,
}
